module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp12_8003.684a6464.png";